import { useEffect } from "react";

import { PushTopic } from "@seneca/notifications-service-types";

import { analyticsLogUserClickedOnPushNotification } from "../";
import { NotificationType } from "../consts";
import isSupportedPushAnalyticsSource from "../utils/isSupportedPushAnalyticsSource";

export default function usePushNotificationsAnalytics({
  pushSource,
  notificationType
}: {
  pushSource?: PushTopic | null;
  notificationType: NotificationType | null;
}) {
  const isPush = notificationType === NotificationType.PUSH;
  const isSupportedSource = isSupportedPushAnalyticsSource(pushSource);
  const shouldLogAnalytics = isPush && isSupportedSource;

  useEffect(() => {
    if (shouldLogAnalytics) {
      const timeout = setTimeout(() => {
        analyticsLogUserClickedOnPushNotification(pushSource!);

        clearTimeout(timeout);
      }, 5000);
    }
  }, [shouldLogAnalytics, pushSource]);
}
